import reduce from 'lodash/reduce';
export default (function (obj, func) {
  return reduce(obj, function (memo, val, key) {
    var output = memo;
    output[key] = func(val);
    return output;
  }, {});
});